<template lang="html">
  <div class="footer">
    <div class="max-width row-block">
      <div class="row-block" :style="{ flex: 1 }">
        <span>聯絡管理員：<a href="mailto:agritrade@tari.gov.tw">agritrade@tari.gov.tw</a></span>
        <div :style="{ flex: 1, maxWidth: '20px', minWidth: '10px' }"></div>
        <div class="info">
          <span>數據更新日期</span>
          <div v-if="source && Object.keys(source).length" class="info-container">
            <span class="info-bor-cor"></span>
            <div class="info-block default-shadow">
              <div class="title">數據更新日期:</div>
              <div class="content col-block">
                <div class="data row-block" v-for="(update, source, index) in source" :key="index">
                  <span>{{ source }}</span>
                  <div :style="{ width: '10px' }"></div>
                  <span>{{ update }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <a class="title" href="https://www.tari.gov.tw" target="_blank">農業部農業試驗所 版權所有 © 2019</a>
      <span class="row-block" :style="{ flex: 1 }">
        <div :style="{ flex: 1 }"></div>
        <a class="title" href="https://www.compassbioinfo.com" target="_blank">康百事生物資訊股份有限公司</a>
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'source'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/footer.vue